import { render } from "./CaseIcon.vue?vue&type=template&id=6aabcb01"
import script from "./CaseIcon.vue?vue&type=script&lang=js"
export * from "./CaseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__